<template>
  <div :class="{'no-data': true, active: visible}">
    <div class="no-data-content">
      <div class="no-data-icon">
        <svg
          width="64"
          height="41"
          viewBox="0 0 64 41"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            transform="translate(0 1)"
            fill="none"
            fill-rule="evenodd"
          >
            <ellipse
              class="no-data-icon-simple-ellipse"
              cx="32"
              cy="33"
              rx="32"
              ry="7"
            />
            <g
              class="no-data-icon-simple-g"
              fill-rule="nonzero"
            >
              <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z" />
              <path
                d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                class="ant-empty-img-simple-path"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="no-data-description">
        No Data
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  display: none;
  position: relative;
  width: 100%;
  height: 400px;
  &.active {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.no-data-content {
  display: inline-block;
  margin: 32px 0;
  color: rgba(0,0,0,.25);
}

.no-data-icon {
  .no-data-icon-simple-ellipse {
    fill: #f5f5f5;
  }
  .no-data-icon-simple-g {
    stroke: #d9d9d9;
  }
}

.no-data-description {
  text-align: center;
}
</style>
